module.exports = new __parcel__URL__("plasma_cannon_level_1_skin.fc84fd8b.png").toString();